import { render, staticRenderFns } from "./AppRoot.vue?vue&type=template&id=3dc6fb86"
import script from "./AppRoot.vue?vue&type=script&lang=js"
export * from "./AppRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports